// extracted by mini-css-extract-plugin
module.exports = {"comm":"comm_comm__1XYxn","ourServices":"comm_ourServices__3VvMD"};